import React from 'react';
import { Card, Tabs, Tab, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ClaimIcsEventTemplateConfigure from '../claim/templates/ClaimIcsEventTemplateConfigure';
import EmailPreviewModalRecipients from '@components/shared/claim/emailPreview/EmailPreviewModalRecipients';
import EmailPreviewModalPreview from '@components/shared/claim/emailPreview/EmailPreviewModalPreview';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import PastSentEmailList from '../claim/emailPreview/PastSentEmailList';
import { TEMPLATE_HEADER_TITLE } from '@rd-web-markets/market/dist/constants';

const ScheduleEmail = ({
  claimGroup,
  sendIcsEventMail,
  onClaimScheduleClientContactParticipationChange,
  onClaimGroupUpdate,
  setClaimGroup,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <h2 className="text-primary mb-4">{t('schedule_email')}</h2>
      <Tabs defaultActiveKey="configure" className="mb-3">
        <Tab eventKey="configure" title={`${t('configure_email')}`}>
          <ClaimIcsEventTemplateConfigure claimGroup={claimGroup} setClaimGroup={setClaimGroup} />
        </Tab>
        <Tab eventKey="preview" title={`${t('preview')}`}>
          {!claimGroup.claim_schedule.active_claim_schedule_ics_event_template && <Card><Card.Header>{t(TEMPLATE_HEADER_TITLE.claim_schedule_ics_event_template)}</Card.Header></Card>}
          {!!claimGroup.claim_schedule.active_claim_schedule_ics_event_template &&
            <Card>
              <Card.Header>
                <EmailPreviewModalRecipients
                  setClaimGroup={setClaimGroup}
                  claimGroup={claimGroup}
                  emailType={'kickoff'}
                  claimSchedule={claimGroup.claim_schedule}
                  onClaimGroupRolesupdate={onClaimGroupUpdate}
                  onClaimScheduleUpdate={onClaimScheduleClientContactParticipationChange}
                />
              </Card.Header>
              <Card.Body>
                <EmailPreviewModalPreview claimGroup={claimGroup} template={claimGroup.claim_schedule.active_claim_schedule_ics_event_template} />
                <Row className='align-items-center'>
                  <Col md={9}>
                    <PastSentEmailList claimGroup={claimGroup} pastSentTemplatesList={claimGroup.claim_schedule.claim_schedule_ics_event_templates} />
                  </Col>
                  <Col md={3}>
                    <Button
                      loading={loading}
                      icon='mail'
                      iconPosition={'left'}
                      variant="success"
                      className="float-end"
                      onClick={() => sendIcsEventMail()}>
                      {t('send_event_mail')}
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          }
        </Tab>
      </Tabs>
    </>
  )
};

export default ScheduleEmail;